
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.18 3.727L8.198 6.708l1.419 1.419 2.981-2.982c1.23-1.23 3.194-1.278 4.364-.107 1.17 1.17 1.122 3.134-.107 4.364l-2.982 2.981 1.419 1.419 2.981-2.982c2.057-2.057 2.138-5.315.18-7.273-1.958-1.958-5.216-1.877-7.273.18zm1.203 10.146l-2.981 2.982c-1.23 1.23-3.194 1.278-4.364.107-1.17-1.17-1.122-3.134.107-4.364l2.982-2.981-1.419-1.419-2.981 2.982c-2.057 2.057-2.138 5.315-.18 7.273 1.958 1.958 5.216 1.877 7.273-.18l2.982-2.981-1.419-1.419zm.889-6.563l-5.963 5.962 1.419 1.419 5.963-5.963-1.42-1.418z","fill":"#fff"}})])
          )
        }
      }
    